import React from 'react'
import cn from 'classnames'
import styled from '@emotion/styled'

import SelectableItem from 'shared/ui/Dropdown/SelectableItem'

import { propFunc } from 'util/functions'

import withListController from './withListController'
import ScrollPane from './ScrollPane'
import ListItem from './TicketListItem'
import styles from '../styles.css'

const Item = styled(
  ({
    className,
    hideCustomer,
    index,
    key,
    onClick,
    selected,
    sendingDelayed,
    ticket,
  }) => {
    return (
      <SelectableItem
        className={cn('grui py-4 pl-12 pr-10', className)}
        content={
          <ListItem
            className={cn(styles.ticketWithScroller, {
              [styles.ticketWithScrollerFirstItem]: index === 0,
            })}
            key={ticket.id}
            ticket={ticket}
            onClick={onClick}
            hideCustomer={hideCustomer}
            sendingDelayed={sendingDelayed}
          />
        }
        key={key}
        selected={selected}
      />
    )
  }
)`
  display: flex;

  &:first-child {
    margin-top: 8px;
  }

  &:last-child {
    margin-bottom: 16px;
  }

  .Icon-keyboard-return {
    line-height: 40px;
  }
`

function buildItems({
  delayedTicketIds,
  focusedIndex,
  hideCustomer,
  items = [],
  onSelect,
}) {
  return items.filter(e => e).map((ticket, index) => {
    const sendingDelayed = delayedTicketIds.includes(ticket.id)
    return (
      <Item
        hideCustomer={hideCustomer}
        index={index}
        key={ticket.id}
        onClick={!sendingDelayed ? propFunc(onSelect, ticket.id) : undefined}
        selected={index === focusedIndex}
        sendingDelayed={sendingDelayed}
        ticket={ticket}
      />
    )
  })
}

const Options = ({
  delayedTicketIds,
  focusedIndex,
  hasMore,
  hideCustomer = false,
  isLoadingMore,
  items,
  loadMore,
  onSelect,
}) => {
  return (
    <ScrollPane
      hasMore={hasMore}
      loadMore={loadMore}
      isLoadingMore={isLoadingMore}
    >
      {buildItems({
        delayedTicketIds,
        focusedIndex,
        hideCustomer,
        items,
        onSelect,
      })}
    </ScrollPane>
  )
}

export default withListController(Options)
